
import Vue from 'vue';
import VueRouter from 'vue-router';

import Dashboard from '../components/Dashboard.vue'
import Products from '../components/Products.vue'
import Product from '../components/Product.vue'
import Activate from '../components/Activate.vue'
import InstantActivate from '../components/InstantActivate'
import InstantActivateSuccess from '../components/InstantActivateSuccess'
import BasketAssign from '../components/BasketAssign.vue'
import Checkout from '../components/Checkout.vue'
import Home from '../components/Home2.vue'
import Register from '../components/Register.vue'
import RegisterIndividual from '../components/RegisterIndividual.vue'
import RegisterOrganisation from '../components/RegisterOrganisation.vue'
import LoginForm from '../components/LoginForm.vue'
import Nominate from '../components/Nominate.vue'
import ForgotPassword from '../components/ForgotPassword.vue'
import ResetPasswordForm from '../components/ResetPasswordForm.vue'
import {userService} from "../services";
import HowItWorks from "../components/HowItWorks";
import Account from "../components/Account";
import Guide from "../components/Guide"
import Individuals from '../components/Individuals.vue'
import Organisations from '../components/Organisations.vue'
import Verify from '../components/Verify.vue'
import Verified from '../components/Verified.vue'
import PrivacyPolicy from '../components/PrivacyPolicy.vue'
import ContactUs from '../components/ContactUs.vue'
import Cookies from '../components/Cookies.vue'
import NotFound from '../components/NotFound.vue'
import Environment from '../components/Environment'
import Found from '../components/Found'
import AgreeTerms from '../components/AgreeTerms'
import Terms from '../components/Terms'
import Landing from '../components/Landing'
import Faqs from "../components/Faqs";
import OptOut from "../components/OptOut"
import About from "../components/About"

Vue.use(VueRouter)
import { store } from '../store';

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        props: true
    },
    {
        path: '/our-story',
        name: 'our-story',
        component: About
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        beforeEnter: (to, from, next) => {
            let user = store.getters['account/user']
            if (user && user.roles && user.roles.includes('organisation') === false) {
                router.push({ name: 'home'})
            }
            else if(user && user.email_verified_at == null) {
                router.push({ name: 'verify'})
            }
            else if(user && user.admin_for_organisations[0] && !user.admin_for_organisations[0].terms_agreed) {
                store.dispatch('lastRoute', 'dashboard')
                router.push({ name: 'agree-terms'});
            }
            else {
                next();
            }
        }
    },
    {
        path: '/environment',
        name: 'environment',
        component: Environment,
    },
    {
        path: '/found',
        name: 'found',
        component: Found,
        // beforeEnter: (to, from, next) => {
        //     let user = store.getters['account/user']
        //     if (user && user.roles && user.roles.includes('organisation') === false) {
        //         router.push({ name: 'home'})
        //     }
        //     else if(user && user.email_verified_at == null) {
        //         router.push({ name: 'verify'})
        //     } else {
        //         next();
        //     }
        // }
    },
    {
        path: '/found/:qrCode',
        name: 'dashboard-found',
        props: true,
        component: Found,
        // beforeEnter: (to, from, next) => {
        //     let user = store.getters['account/user']
        //     if (user && user.roles && user.roles.includes('organisation') === false) {
        //         router.push({ name: 'home'})
        //     }
        //     else if(user && user.email_verified_at == null) {
        //         router.push({ name: 'verify'})
        //     } else {
        //         next();
        //     }
        // }
    },
    {
        path: '/p2p/:qrCode',
        redirect: to => {
            return { path: '/found/' + to.params.qrCode, }
        },
    },
    {
        path: '/account',
        name: 'account',
        component: Account,
        beforeEnter: (to, from, next) => {
            let user = store.getters['account/user']
            let loggedIn = store.getters['account/loggedIn']
            if (loggedIn !== true) {
                store.dispatch('lastRoute', 'account')
                router.push({ name: 'login'})
            }
            else if (user && user.email_verified_at == null) {
                router.push({ name: 'verify'})
            }
            else if(user && user.admin_for_organisations[0] && !user.admin_for_organisations[0].terms_agreed) {
                store.dispatch('lastRoute', 'account')
                router.push({ name: 'agree-terms'});
            }
            else if(user && !user.roles.includes('organisation') && !user.terms_agreed) {
                store.dispatch('lastRoute', 'account')
                router.push({ name: 'agree-terms'});
            }
            else {
                next();
            }
        }
    },
    {
        path: '/shop',
        name: 'products',
        component: Products,
        beforeEnter: (to, from, next) => {
            let user = store.getters['account/user']
            if (user && user.roles && user.roles.includes('organisation')) {
                router.push({ name: 'home'})
            }
            else {
                next();
            }
        }
    },
    {
        path: '/shop/:slug',
        name: 'product',
        component: Product,
        props: true,
        beforeEnter: (to, from, next) => {
            let user = store.getters['account/user']
            if (user && user.roles && user.roles.includes('organisation')) {
                router.push({ name: 'home'})
            }
            else {
                next();
            }
        }
    },
    {
        path: '/activate',
        name: 'activate',
        component: Activate,
        beforeEnter: (to, from, next) => {
            let user = store.getters['account/user']
            let loggedIn = store.getters['account/loggedIn']
            let subscribed = store.getters['account/hasMembership']
            let activeTrail = store.getters['account/hasActiveTrial']

            if (loggedIn !== true) {
                store.dispatch('lastRoute', 'activate')
                router.push({ name: 'login'})
            }
            else if(user && user.email_verified_at == null) {
                router.push({ name: 'verify'})
            }
            else if (user && user.roles && user.roles.includes('organisation')) {
                router.push({ name: 'home'})
            }
            else if(user && !user.terms_agreed) {
                store.dispatch('lastRoute', 'activate')
                router.push({ name: 'agree-terms'});
            }
            // else if(!subscribed && !activeTrail) {
            //     router.push({ name: 'account'})
            // }
            else {
                next();
            }
        }
    },
    {
        path: '/intro-activate',
        name: 'intro-activate-empty',
        component: InstantActivate
    },
    {
        path: '/intro-activate/:qrCode',
        name: 'intro-activate',
        component: InstantActivate,
        props: true
    },
    {
        path: '/intro-activate-success',
        name: 'intro-activate-success',
        component: InstantActivateSuccess
    },
    {
        path: '/how-it-works',
        name: 'how-it-works',
        component: HowItWorks
    },
    {
        path: '/guide/:slug',
        name: 'guide',
        component: Guide,
        props: true
    },
    {
        path: '/basket',
        name: 'basket',
        component: BasketAssign,
        beforeEnter: (to, from, next) => {
            let user = store.getters['account/user']
            let loggedIn = store.getters['account/loggedIn']
            if(loggedIn !== true) {
                userService.logout()
                router.push({ name: 'login'})
            }
            else if(user && user.email_verified_at == null) {
                router.push({ name: 'verify'})
            } else {
                next();
            }
        }
    },
    {
        path: '/checkout',
        name: 'checkout',
        component: Checkout,
        beforeEnter: (to, from, next) => {
            let user = store.getters['account/user']
            let loggedIn = store.getters['account/loggedIn']
            if(loggedIn !== true) {
                userService.logout()
                router.push({ name: 'login'})
            }
            else if(user && user.email_verified_at == null) {
                router.push({ name: 'verify'})
            }
            else if(user && !user.terms_agreed) {
                store.dispatch('lastRoute', 'checkout')
                router.push({ name: 'agree-terms'});
            }
            else {
                next();
            }
        }
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: Register
    },
    {
        path: '/sign-up/:slug',
        name: 'partner-landing',
        component: Landing,
        props: true
    },
    {
        path: '/sign-up-individual',
        name: 'sign-up-individual',
        component: RegisterIndividual
    },
    {
        path: '/sign-up-organisation',
        name: 'sign-up-organisation',
        component: RegisterOrganisation
    },
    {
        path: '/nominate',
        name: 'nominate',
        component: Nominate
    },
    {
        path: '/individuals',
        name: 'individuals',
        component: Individuals
    },
    {
        path: '/organisations',
        name: 'organisations',
        component: Organisations
    },
    {
        path: '/login',
        name: 'login',
        component: LoginForm,
        beforeEnter: (to, from, next) => {
            store.dispatch('lastRoute', 'home')

            let loggedIn = store.getters['isAuthenticated']

            if(loggedIn) {
                router.push({ name: 'home'})
            } else {
                next();
            }
        }
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter: (to, from, next) => {
            //let loggedIn = store.getters['isAuthenticated']

            userService.logout()
            router.push({ name: 'login'})

            // if(loggedIn) {
            //     userService.logout()
            //     router.push({ name: 'login'})
            // } else {
            //     router.push({ name: 'login'})
            // }
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: ForgotPassword,
        meta: {
            auth:false
        }
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password-form',
        component: ResetPasswordForm,
        meta: {
            auth: false
        }
    },
    {
        path: '/verify',
        name: 'verify',
        component: Verify
    },
    {
        path: '/verified',
        name: 'verified',
        component: Verified
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: PrivacyPolicy
    },
    {
        path: '/cookie-declaration',
        name: 'cookies',
        component: Cookies
    },
    {
        path: '/contact-us',
        name: 'contact-us',
        component: ContactUs
    },
    {
        path: '/agree-terms',
        name: 'agree-terms',
        component: AgreeTerms,
        beforeEnter: (to, from, next) => {
            let loggedIn = store.getters['account/loggedIn']
            if(loggedIn !== true) {
                store.dispatch('lastRoute', 'agree-terms')
                router.push({ name: 'login'})
            }
            else {
                next();
            }
        }
    },
    {
        path: '/terms-and-conditions',
        name: 'terms-and-conditions',
        component: Terms
    },
    {
        path: '/frequently-asked-questions',
        name: 'faqs',
        component: Faqs,
    },
    {
        path: '/opt-out-reminders',
        name: 'opt-out-reminders',
        component: OptOut,
    },
    {
        path: '*',
        name: 'not-found',
        component: NotFound // 404
    }
]

// You can pass in additional options here, but let's
// keep it simple for now.
export const router = new VueRouter({
    mode: 'history',
    routes // short for `routes: routes`
})
